export default "__VITE_ASSET__08f4ee75__"